import {ContentBox} from '@hconnect/common/components'
import CloseIcon from '@mui/icons-material/Close'
import {IconButton, Typography} from '@mui/material'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../../consts'
import {HProduceTask} from '../../types'

import {TaskCreateFactory} from './TaskCreateFactory'

type Props = {
  onClose: (original?: HProduceTask, next?: HProduceTask) => void
}

export const TaskCreate = ({onClose}: Props) => {
  return (
    <NewTaskCardBox onClose={onClose}>
      <TaskCreateFactory onClose={onClose} />
    </NewTaskCardBox>
  )
}

type NewTaskCardBoxProps = Pick<Props, 'onClose'> & {
  children: React.ReactNode
}

const NewTaskCardBox: React.FC<NewTaskCardBoxProps> = ({children, onClose}) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)

  return (
    <ContentBox
      mode="max100PercentOfParentHeight"
      bodyWithPadding
      title={
        <Typography component="span" variant="h2">
          {t('task.label.newTask')}
        </Typography>
      }
      afterTitle={
        <IconButton data-test-id="CloseIcon" onClick={() => onClose()}>
          <CloseIcon color="primary" />
        </IconButton>
      }
      headerSx={{paddingBottom: 0}}
    >
      {children}
    </ContentBox>
  )
}
